/**
 * GapCursor Plugin Extension
 * 允许在块级元素之间放置光标
 */

import type { Schema, Plugin } from '../../core/types';
import { PluginExtension } from '../../core/Extension';
import { gapCursor } from 'prosemirror-gapcursor';

export class GapCursor extends PluginExtension {
  get name(): string {
    return 'gapCursor';
  }

  plugins(_schema: Schema): Plugin[] {
    return [gapCursor()];
  }
}
